import moment from "./moment"

const getValidateCouponForOrdersRequestData = (
  previuosDiscounts,
  deliveryFees,
  orderItems,
  deliveryType
) => {
  const totalDeliveryDiscount =
    previuosDiscounts.reduce((t, discount) =>
      t += discount.deliveryDiscount,
      0
    )

  const itemsWithoutSystemDiscount =
    orderItems.filter(orderItem =>
      !orderItem.systemDiscount
    )

  const items =
    itemsWithoutSystemDiscount.map((item, iIndex) => {
      const totalFoodDiscounts =
        previuosDiscounts.reduce((t, discount) =>
          t += discount.items[iIndex].foodDiscount
          , 0
        )

      const discount =
        totalFoodDiscounts / item.quantity

      const salePrice = item.salePrice - discount

      const totalSpecificationSalePrice =
        item.specificationItems.reduce((t, specificationItem) =>
          t +=
          item.quantity *
          specificationItem.salePrice *
          (specificationItem.quantity - specificationItem.freeQuantity)
          , 0
        )

      return {
        salePrice,
        foodId: item.foodId,
        quantity: item.quantity,
        totalSpecificationSalePrice
      }
    })

  const deliveryFee =
    deliveryType === "delivery" ?
      Number(deliveryFees.fee - totalDeliveryDiscount) : 0

  const date = moment().toISOString()

  return [{ date, items, deliveryFee }]
}

export default getValidateCouponForOrdersRequestData